/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Finance_PacksInputs */

const en_features_finance_packs = /** @type {(inputs: Features_Finance_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packs sold`)
};

const pl_features_finance_packs = /** @type {(inputs: Features_Finance_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedane pakiety`)
};

/**
* | output |
* | --- |
* | "Packs sold" |
*
* @param {Features_Finance_PacksInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_finance_packs = /** @type {((inputs?: Features_Finance_PacksInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Finance_PacksInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_finance_packs(inputs)
	return en_features_finance_packs(inputs)
});